import { Badge } from "../../@/components/ui/badge";

export const ScheduleItem = ({
  title,
  startTime,
  endTime,
  location,
  href,
  isLive = false,
  variant = "default",
}) => {
  const bgColor = variant === "primary" ? "bg-(--neutral-100)" : "bg-none";
  const textColor =
    variant === "primary" ? "text-(--neutral-950)" : "text-(--neutral-700)";
  const timeTextColor =
    variant === "primary" ? "text-(--neutral-950)" : "text-(--neutral-700)";
  const borderClass = variant === "primary" ? "border-y" : "border-b";

  const content = (
    <div className={`${bgColor} ${borderClass} border-(--neutral-300) p-4`}>
      <div className={`mb-1 text-h6 font-heading ${textColor} flex items-center gap-2`}>
        <span>{title}</span>
        {isLive && (
          <Badge
            variant={"completed"}
            className="bg-[var(--color-success)] text-white"
          >
            Live
          </Badge>
        )}
      </div>
      <p className={`line-clamp-1 font-body ${timeTextColor}`}>
        {startTime} - {endTime} · <span className="">{location}</span>
      </p>
    </div>
  );

  if (href) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="block"
      >
        {content}
      </a>
    );
  }

  return content;
};